import docReady from './Functions/docReady'

docReady(function () {
    document.body.classList.add('page-front');
    if (!document.body.classList.contains('hideHeader')) {
        document.getElementsByClassName('pic-navbar')[0].classList.add('pic-navbar-bigger');
    }
    var navButtons = document.getElementById('pic-navbar-buttons');
    navButtons.style.pointerEvents = 'none';
    navButtons.style.opacity = 0;

    document.addEventListener('scroll', function (e) {
        var window_offset = document.getElementById('bigbuttons').offsetTop - window.pageYOffset;
        if (window_offset < 0) {
            navButtons.style.pointerEvents = 'auto';
            navButtons.style.opacity = 1;
        } else {
            navButtons.style.opacity = 0;
            navButtons.style.pointerEvents = 'none';
        }
        if (!document.body.classList.contains('hideHeader')) {
            if (window.pageYOffset < 50) {
                document.getElementsByClassName('pic-navbar')[0].classList.add('pic-navbar-bigger');
            } else {
                document.getElementsByClassName('pic-navbar')[0].classList.remove('pic-navbar-bigger');
            }
        }
    });

});
new Vue({
    el: '#welcome',
    data: {
        activeBackground: '',
        activeSlogan: 0,
        slogan: '',
        backgroundUrl: '',
    },
    methods: {
        updateSlogan: function () {
            this.slogan = model.slogans[this.activeSlogan];

            this.activeSlogan++;
            if (this.activeSlogan >= model.slogans.length) { this.activeSlogan = 0; }
        },
        updateBackground: function () {
            this.backgroundUrl = model.backgroundPicture;
        }
    },
    mounted: function () {
        this.updateSlogan();
        this.updateBackground();
        if (model.slogans.length > 1) {
            setInterval(this.updateSlogan, 7000);
        }
    //    if (model.backgroundPicture.length > 1) {
    //        setInterval(this.updateBackground, 10000);
    //    }
    }
});